import { resolveAvatarUrl } from '@/utils/avatar';

const medalIcons = { 1: '1', 2: '2', 3: '3' };

export default function RankingCard({ entry, index, isMe }) {
  const rank = entry.rank || index + 1;

  return (
    <div className={`flex items-center gap-3 p-3 rounded-2xl border transition-all ${
      isMe ? 'border-accent bg-accent/10' : 'border-edge bg-surface'
    }`}>
      <div className="w-8 text-center font-urban font-bold text-lg text-fg">
        {medalIcons[rank] || <span className="text-muted text-base">#{rank}</span>}
      </div>
      <div className="w-10 h-10 rounded-full overflow-hidden border-2 border-accent/30 flex-shrink-0 bg-surfaceAlt flex items-center justify-center">
        {entry.player?.avatarUrl
          ? <img src={resolveAvatarUrl(entry.player.avatarUrl)} alt="Avatar" className="w-full h-full object-cover" />
          : <span className="text-xl">HC</span>
        }
      </div>
      <div className="flex-1 min-w-0">
        <div className={`font-body font-bold text-sm truncate ${isMe ? 'text-accent' : 'text-fg'}`}>
          {entry.player?.displayName || entry.player?.username}
        </div>
        <div className="text-xs text-muted">Nivel {entry.player?.level}</div>
      </div>
      <div className="text-right">
        <div className="font-urban font-bold text-accent text-base">{entry.score?.toLocaleString('pt-PT')}</div>
        <div className="text-xs text-muted">XP</div>
      </div>
    </div>
  );
}
